export const WCAG_CONTRAST_RATIOS = {
    AA: {
        NORMAL: 4.5,
        LARGE: 3,
    },
    AAA: {
        NORMAL: 7,
        LARGE: 4.5,
    },
};
